export default "__VITE_ASSET__B8V4Ozo4__"